import styled from 'styled-components'
import { rem } from 'polished'

import ToggleButton from 'LuxKit/ToggleButton'
import { StyledSvgIcon, setSvgIconSize } from 'LuxKit/SvgIcon'

export const ExperiencesHomepageCategoryStripToggleButton = styled(ToggleButton)`
  &.kind-secondary.orientation-horizontal {
    gap: ${rem(8)};
    min-block-size: ${rem(40)};
    min-inline-size: ${rem(80)};
    padding: ${rem(8)} ${rem(20)};
  }

  &.kind-secondary.orientation-horizontal .content-colour-normal-contrast {
    font-weight: ${props => props.theme.font.primary.weight.bold};
    text-align: start;
  }

  &.kind-secondary.orientation-horizontal .content-colour-light-foreground-alt {
    color: ${props => props.theme.palette.neutral.default.three};
    font-weight: ${props => props.theme.font.primary.weight.regular};
    text-align: start;
  }

  > ${StyledSvgIcon} {
    ${setSvgIconSize(28)}
  }
`
